'use strict';

import { CalendarAvailability } from "../../utils/pricetravel/shared/calendarAvailability";
import { setPicker, getPickerDates, resetDates } from "../../utils/constants/datePicker";
import GlobalUtil from '../../utils/pricetravel/shared/globalUtil';
window.app.controller('SmallBookerController', controller);

controller.$inject = ["$scope", "$http", "$q", "$timeout", "localStorageService", "$location", "$rootScope"];

function controller($scope, $http, $q, $timeout, localStorageService, $location, $rootScope) {

    let vm = this;
    let config = window.__pt.settings.site;
    let setting = window.__pt.settings;
    let lang = window.__pt.ln;
    let fn = window.__pt.fn;
    let defaultDate = fn.getDate();
    let _place = window.__pt.place || {};
    let _datePicker = {};
    let _picker = null;
    let box = window.__pt.box || null;
    let _globalUtil = new GlobalUtil();
    let localeDatePicker = {
        formatMobile: setting.formatBoxDateMobile,
        firstDay: 0,
        applyLabel: lang.ok,
        cancelLabel: lang.cancel
    };
    let elements = {};
    let datesQuote = {};

    vm.submit = false;
    vm.years = [];
    vm.suggestion = {
        paxes: false
    };
    vm.dataCopyCancel = setting.defaultHotel;
    vm.validation = {
        paxes: true,
        checkIn: true,
        checkOut: true,
        dates: true
    }

    vm.settingPaxes = {
        minAdults: 1,
        maxAdults: 8,
        minChildren: 0,
        maxChildren: 6,
        minAge: 0,
        maxAge: 17,
        rooms: 8
    };


    // get cookies//
    let configDaysPrequote = {
        weeksPrequote: 0,
        daysPrequote: 0,
        startDate: 0
    }
    vm.data = setting.defaultHotel;
    vm.display = true;
    vm.onSubmit = (form, fromComponent = false) => {
        const { checkin, checkout } = getPickerDates();
        if (checkin && checkout && !fromComponent){
            vm.data.checkIn = checkin;
            vm.data.checkOut = checkout;
        }
        resetDates();
        vm.validation.paxes = isValidPaxSm(vm.data.paxes, form);

        if (form.$valid && vm.validation.paxes) {
            vm.data.typeEvent = "habitaciones";
            $rootScope.$broadcast(setting.bookerSearchEvent, vm.data);
            vm.form2.$pristine = false;
            vm.form2.$dirty = false;
            vm.form2.$submitted = false;
        } else {
            if (!vm.validation.paxes)
                vm.suggestion.paxes = true;
        }

    }
    $rootScope.$on(setting.bookerSearchEventSmall, function (event, args) {
        vm.data.paxes = args.paxes;
        vm.data.checkIn = args.checkIn;
        vm.data.checkOut = args.checkOut;
        _picker.setDateRange(vm.data.checkIn, vm.data.checkOut);
        updateInputPaxes();
    });
    vm.showPaxes = () => {
        vm.suggestion.paxes = true;
        vm.dataCopyCancel = angular.copy(vm.data);
        getRestMobile("hidden");
    }

    vm.addRoom = () => {
        if (vm.settingPaxes.rooms > vm.data.paxes.length) {
            const paxesDefault = fn.clone(setting.defaultPaxes);
            vm.data.paxes.push(paxesDefault);
            updateInputPaxes();
        }

    }

    vm.onFocus = (element, input) => {
        if (vm.suggestion[element]["results"].length) {
            setTimeout(() => {
                $scope.$apply(() => {
                    vm.suggestion[element]["show"] = true;
                    if (fn.mobileAndTabletCheck()) {
                        onFocusElement(`${input}_modal`)
                    }
                });
            }, 250)
        }
    }

    vm.removePax = (prop, minValue) => {
        if ((vm.data.paxes[prop] - 1) >= minValue) {
            vm.data.paxes[prop] -= 1;
        }
        updateInputPaxes();
    }

    vm.addPax = (prop, maxValue) => {
        if ((vm.data.paxes[prop] + 1) <= maxValue) {
            vm.data.paxes[prop] += 1;
        }
        updateInputPaxes();
    }


    vm.removeChildren = (prop, minValue) => {
        if ((vm.data.paxes[prop].length - 1) >= minValue) {
            vm.data.paxes[prop].splice(vm.data.paxes[prop].length - 1, 1);
        }
        updateInputPaxes();
    }

    vm.addChildren = (prop, maxValue) => {
        if ((vm.data.paxes[prop].length + 1) <= maxValue) {
            vm.data.paxes[prop].push({
                year: null
            });
        }
        updateInputPaxes();

    }
    vm.addRoom = (prop) => {
        if (vm.settingPaxes.rooms <= vm.data.paxes[prop]) {
        } else {
            vm.data.paxes[prop] += 1;
            updateInputPaxes();
        }
    }
    vm.removeRoom = (prop) => {
        if ((vm.data.paxes[prop] + 1) > 2) {
            vm.data.paxes[prop] -= 1;
        }
        updateInputPaxes();
    }
    vm.onClose = (obj, prop) => {

        if (somePaxHasError()) {
            vm.form2.$setSubmitted();
            return;
        }
        getRestMobile("auto");
        obj[prop] = false;
        setValidation(prop);
    }
    vm.onCloseCancel = (obj, prop) => {

        vm.data = vm.dataCopyCancel;
        obj[prop] = false;
        setValidation(prop);
        getRestMobile("auto");
    }
    vm.onCloseSubmitForm = (element, prop) => {
        if (!somePaxHasError() && !vm.form2.$invalid) {
            getRestMobile("auto");
            vm.placeInputHasFocus = false;
            element[prop] = false;
            vm.onSubmit(vm.form2);
        } else {
            vm.form2.$setSubmitted();
            return;
        }    
    }
    vm.onRemove = (obj, prop, index) => {
        obj[prop].splice(index, 1);
        updateInputPaxes();
    }


    vm.hasError = (form, property) => {
        let input = form[property];
        return form.$submitted && input.$invalid
    }

    vm.onClickOutside = (element, prop) => {
        getRestMobile("auto");
        vm.placeInputHasFocus = false;
        element[prop] = false;
        setValidation(prop);
        vm.placeInputHasFocus = false;

    }

    vm.showBooker = () => {
        vm.display = !vm.display;
    }


    vm.isInvalidInput = (form, inputName, inputNumber) => {
        return form.$submitted && form[`${inputName}_${inputNumber}`].$invalid
    }

    /***** Private *****/
    function init() {
        initialDefaultDate();
        initSearchBox();
        initDatePicker();
        updateInputPaxes();

        for (let index = vm.settingPaxes.minAge; index <= vm.settingPaxes.maxAge; index++) {
            vm.years.push({ year: index });
        }
    }

    function initSearchBox() {
        let paramsData, storageData;

        if (setting.page == 'hotels' || setting.page == 'hotel') {
            vm.display = !fn.mobileAndTabletCheck();

            if (setting.rb) {
                vm.display = true;
            }
        }

        if (setting.page != 'home') {
            paramsData = getUserSelectionParams();
        } else {
            storageData = localStorageService.get('bookerHotel_fam');
        }

        if (storageData) {
            storageData.place_name = null;
        }

        vm.data = paramsData || storageData || vm.data;
        if (_globalUtil.getIsArray(vm.data.paxes)) {
            vm.data.paxes =  _globalUtil.convertPaxesData(vm.data.paxes);
        }
        if (paramsData || storageData) {
            vm.data.checkIn = fn.getDate(vm.data.checkIn);
            vm.data.checkOut = fn.getDate(vm.data.checkOut);

            if ((+vm.data.checkIn <= +defaultDate) || (+vm.data.checkOut <= +defaultDate)) {
                initialDefaultDate();
            }
        }
    }

    function initDatePicker() {
        if ((defaultDate < fn.getDate(vm.data.checkOut) || defaultDate >= fn.getDate(vm.data.checkOut)) && box) {
            vm.data.checkIn = fn.getDate(box.checkIn);
            vm.data.checkOut = fn.getDate(box.checkOut);
        }

        onInitPicker(['calendar-checkIn-hotel-small', 'calendar-checkOut-hotel-small'], vm.data.checkIn, vm.data.checkOut, 'checkIn', 'checkOut')
    }



    function onInitPicker(element, startDate, endDate, checkIn, checkOut) {
        
        var pathName = _globalUtil.getFirstPathSegment();
        var css = !setting.rb ? [`${config.cloudCdn}/assets/css/dist/${config.siteName}/booker.css?id=${+(new Date())}`] : [];
        _datePicker = {
            element: document.getElementById(element[0]),
            css: css,
            zIndex: 100,
            grid: 2,
            calendars: 2,
            autoApply: true,
            readonly: true,
            lang: config.culture,
            date: startDate,
            format: fn.mobileAndTabletCheck() && pathName == "hotel" ? localeDatePicker.formatMobile :  localeDatePicker.format,
            plugins: [
                "RangePlugin",
                "LockPlugin"
            ],
            LockPlugin: {
                minDate: defaultDate,
                minDays: 2
            },
            RangePlugin: {
                tooltip: true,
                startDate: startDate,
                endDate: endDate,
                tooltipNumber(num) {
                    return num - 1;
                },
                locale: {
                    one: lang.night,
                    other: lang.night + 's',
                }
            },
            setup(picker) {
                picker.on("render", (e) => {
                    const nextButtons = picker.ui.container.querySelectorAll(".calendars .next-button");
                    const prevButtons = picker.ui.container.querySelectorAll(".calendars .previous-button");
                    if(nextButtons) {
                      nextButtons.forEach((button) => {
                        button.setAttribute('aria-label', 'Siguiente mes');
                      });
                    }
                    if(prevButtons) {
                      prevButtons.forEach((button) => {
                        button.setAttribute('aria-label', 'Anterior mes');
                      });
                    }
                });

                picker.on('select', (e) => {
                    const { start, end } = e.detail;
                    vm.data[checkIn] = start.toJSDate();
                    vm.data[checkOut] = end.toJSDate();
                    vm.onSubmit(vm.form2, true);
                });

                picker.on('view', (evt) => {
                    const { view, date, target } = evt.detail;
                    if (view === 'CalendarDay') {
                        const placeSelected = vm.data.place_selected;
                        const label = date.format('YYYY_MM');
                        const property = date.format('YYYY-MM-DD');

                        datesQuote[label] = label;


                        elements[property] = {
                            date: date.format('YYYY-MM-DD'),
                            target: target
                        };

                        let memory = CalendarAvailability.getMemoryDate(label, property, placeSelected.code || placeSelected.id);
                        if (memory) {
                            CalendarAvailability.buildElement(elements[property], memory);
                        }
                    }

                    if (view === 'Main') {
                        CalendarAvailability.setFooterElement(target);
                        CalendarAvailability.footerBuild();
                    }

                });

                picker.on('show', (evt) => {
                    getAvailability();
                    CalendarAvailability.overFlow();
                });

                picker.on('hide', (evt) => {
                    CalendarAvailability.overFlow();
                    elements = {};
                    datesQuote = {};
                });

                picker.on('click', (e) => {
                    if (picker.isCalendarHeaderButton(e.target)) {
                        elements = {};
                        datesQuote = {};

                        setTimeout(() => {
                            getAvailability();
                        }, 100)
                    }

                    if (picker.isCalendarDay(e.target)) {

                        setTimeout(() => {
                            getAvailability();
                        }, 100)
                    }
                });

            },
        };


        _picker = new easepick.create(_datePicker);
        setPicker(_picker);
    }


    function getUserSelectionParams() {
        let params = fn.search();
        let data = {}
        let place = _place;
        data.place_name = place.displayText || "";
        data.place_selected = place;
        data.checkIn = params.checkin || vm.data.checkIn;
        data.checkOut = params.checkout || vm.data.checkOut;
        let pax = {
            adults: 0,
            children: [],
            rooms: 0
        }
        if (params["room1.adults"]) {
            let rooms = +params.rooms;
            pax.rooms = rooms;
            for (let i = 0; i < rooms; i++) {
                let index = i + 1;
                pax.adults =  parseInt(pax.adults) + parseInt(params[`room${index}.adults`]) || 2;
                let children = params[`room${index}.agekids`];
                if (children) {
                    let childrenSplit = children.split(",");

                    for (var c = 0; c < childrenSplit.length; c++) {
                        pax.children.push({
                            year: +(childrenSplit[c]) || 0
                        })
                    }
                }
            }
        } else {
            var adults = +params.group_adults || 2;
            var rooms = +params.no_rooms || 1;
            var children = [];
            var childrenCount = +params.group_children || 0;

            for (let i = 0; i < childrenCount; i++) {
                var childParam = (params.age || "").split(",")[i];
                var childAge = +childParam || 0;
                children.push({ year: childAge });
            }
            pax.adults = adults;
            pax.rooms = rooms;
            pax.children = children
        }
        if (!pax) {
            pax = vm.data.paxes;
        }
        data.paxes = pax;
        return data;
    }

    function initialDefaultDate() {
        if (fn.mobileAndTabletCheck()) {
            configDaysPrequote.weeksPrequote = config.configDaysPrequoteMobile.weeksPrequote;
            configDaysPrequote.daysPrequote = config.configDaysPrequoteMobile.daysPrequote;
            configDaysPrequote.startDate = config.configDaysPrequoteMobile.startDate;
        } else {
            configDaysPrequote.weeksPrequote = config.configDaysPrequoteDesktop.weeksPrequote;
            configDaysPrequote.daysPrequote = config.configDaysPrequoteDesktop.daysPrequote;
            configDaysPrequote.startDate = config.configDaysPrequoteDesktop.startDate;
        }
        const newDateParse = new Date(defaultDate);
        newDateParse.setDate(newDateParse.getDate() + (configDaysPrequote.weeksPrequote * 7));
        newDateParse.setDate(newDateParse.getDate() - newDateParse.getDay() + configDaysPrequote.startDate);

        vm.data.checkIn = getInitialDate(newDateParse);
        vm.data.checkOut = getInitialDate(newDateParse, configDaysPrequote.daysPrequote);
    }

    function getInitialDate(date = fn.getDate(), value = 0) {
        let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
        dateNew.setDate(dateNew.getDate() + value)
        return dateNew;
    }


    function updateInputPaxes() {
        let adults = 0;
        let children = 0;
        let lengthPax = vm.data.paxes.rooms;
        adults = vm.data.paxes.adults;
        children = vm.data.paxes.children.length;
        const roomTitle = lengthPax == 1 ? lang.room : lang.rooms;
        const adultsTitle = adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = children == 1 ? lang.child : lang.children;
        let childrenText = "";
        if (children > 0) {
            childrenText = ` ${children} ${childrenTitle}, `;
        }
        vm.data.paxes_name = `${adults} ${adultsTitle},${childrenText} ${lengthPax} ${roomTitle}`;
        vm.data.paxes_people = `${adults + children} ${lang.new_pers} ${lengthPax} ${lang.new_room}`;
        vm.data.capacityTotal = adults + children;
    }


    function isValidPaxSm(vmDataPaxes, form) {
        let valid = true;
        const rooms = vmDataPaxes.rooms;

        let childrens = vmDataPaxes.children.length;
        for (let c = 0; c < childrens; c++) {
            let inputKid = form[`children_${c}`];
            if (inputKid.$invalid) {
                valid = false;
                break;
            }
        }

        return valid;
    }


    function isValidPaxSm(pax, form) {
        let valid = true;
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];

            let childrens = room.children.length;
            for (let c = 0; c < childrens; c++) {
                let inputKid = form[`children_${i}_${c}`];
                if (inputKid && inputKid.$invalid) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                break;
            }
        }

        return valid;
    }

    function onFocusElement(nameDiv) {
        setTimeout(() => {
            let element = nameDiv && document.getElementById(nameDiv);
            if (element) {
                element.focus();
            }
        }, 200)

    }

    function setValidation(prop) {
        if (prop == 'paxes') {
            vm.validation.paxes = isValidPaxSm(vm.data.paxes, vm.form2);
        }
    }

    function somePaxHasError() {
        if (vm.data && vm.data.paxes) {
            let pax = vm.data.paxes.children;
            if (pax && pax.length > 0) {
                if (pax.some(child => child.year === null || child.year === undefined)) {
                    return true;
                }
            }
        }
        return false;
    }
    function getRestMobile(overflow) {
        if (window.innerWidth <= 479) {
            if(overflow == "auto"){
                document.body.classList.remove("modal-open");
            }else if(overflow == "hidden"){
                document.body.classList.add("modal-open");
            }
        }else{
            document.body.classList.remove("modal-open");
        }
    }

    let getAvailability = async () => {
        if (config.showCalendarAvailability) {
            let placeSelected = vm.data.place_selected;
            if (placeSelected && placeSelected.type == 14 && (placeSelected.code || placeSelected.id)) {

                for (let calendar in datesQuote) {
                    let calendarData = calendar.split("_");
                    let response = await CalendarAvailability.getAvailability(placeSelected.code || placeSelected.id, calendarData[0], calendarData[1]);
                    CalendarAvailability.build(elements, response);
                }
                CalendarAvailability.footerBuild();
            }
        }
    }
    init();
}
